import { TApplicationState } from '../../types/redux';

export const selectFormPriceRange = (state: TApplicationState) => state.requestFormV2.quiz.priceRange;
